export default __webpack_public_path__ + "static/media/sld.c6522394.png";